module.exports = __webpack_public_path__ + "img/IMG_6748.05c3ee72.gif";